import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../utils/data-load-error/data-load-error";

export enum CandidaturePreviewErrorType {
  PLAN_ENTRY_CANDIDATE_COLLISION = "PLAN_ENTRY_CANDIDATE_COLLISION",
  TAXI_DRIVER_ASSOCIATION_NOT_EXISTS = "TAXI_DRIVER_ASSOCIATION_NOT_EXISTS",
  TAXI_DRIVER_CONTRACT_NOT_VALID = "TAXI_DRIVER_CONTRACT_NOT_VALID",
  TAXI_RAILY_CONTRACT_NOT_VALID = "TAXI_RAILY_CONTRACT_NOT_VALID",
  ORDER_NOT_EXISTS = "ORDER_NOT_EXISTS",
  ORDER_IN_PROGRESS = "ORDER_IN_PROGRESS",
}

export type CandidaturePreviewEntryCandidateCollisionError = DataLoadError<
  CandidaturePreviewErrorType.PLAN_ENTRY_CANDIDATE_COLLISION,
  {}
>;

export type CandidaturePreviewTaxiDriverAssociationNotExistsError =
  DataLoadError<
    CandidaturePreviewErrorType.TAXI_DRIVER_ASSOCIATION_NOT_EXISTS,
    {}
  >;

export type CandidaturePreviewTaxiDriverContractNotValidError = DataLoadError<
  CandidaturePreviewErrorType.TAXI_DRIVER_CONTRACT_NOT_VALID,
  {}
>;

export type CandidaturePreviewTaxiRailyContractNotExistsError = DataLoadError<
  CandidaturePreviewErrorType.TAXI_RAILY_CONTRACT_NOT_VALID,
  {}
>;

export type CandidaturePreviewOrderNotExistsError = DataLoadError<
  CandidaturePreviewErrorType.ORDER_NOT_EXISTS,
  {}
>;

export type CandidaturePreviewOrderInProgressError = DataLoadError<
  CandidaturePreviewErrorType.ORDER_IN_PROGRESS,
  {}
>;

type CandidaturePreviewError =
  | DataLoadDefaultErrors
  | CandidaturePreviewEntryCandidateCollisionError
  | CandidaturePreviewTaxiDriverAssociationNotExistsError
  | CandidaturePreviewTaxiDriverContractNotValidError
  | CandidaturePreviewTaxiRailyContractNotExistsError
  | CandidaturePreviewOrderNotExistsError
  | CandidaturePreviewOrderInProgressError;

export default CandidaturePreviewError;
